import { createSlice, nanoid } from "@reduxjs/toolkit";

const MAX_ITEMS = 40;

const initialState = {
  items: [],
};

const notificationSlice = createSlice({
  name: "notifications",
  initialState,
  reducers: {
    pushNotification: {
      reducer(state, action) {
        state.items.unshift(action.payload);
        while (state.items.length > MAX_ITEMS) {
          state.items.pop();
        }
      },
      prepare({
        title,
        message,
        type = "info",
        link,
        source,
        avatarUrl = null,
        actorName = null,
      }) {
        return {
          payload: {
            id: nanoid(),
            title: title || "Melding",
            message: message || "",
            type,
            link: link || null,
            source: source || null,
            avatarUrl: avatarUrl || null,
            actorName: actorName || null,
            read: false,
            createdAt: Date.now(),
          },
        };
      },
    },
    markNotificationRead(state, action) {
      const item = state.items.find((n) => n.id === action.payload);
      if (item) item.read = true;
    },
    markAllNotificationsRead(state) {
      state.items.forEach((n) => {
        n.read = true;
      });
    },
    dismissNotification(state, action) {
      state.items = state.items.filter((n) => n.id !== action.payload);
    },
    clearNotifications(state) {
      state.items = [];
    },
  },
});

export const {
  pushNotification,
  markNotificationRead,
  markAllNotificationsRead,
  dismissNotification,
  clearNotifications,
} = notificationSlice.actions;

export default notificationSlice.reducer;
